/*
 * ARTMiE Sale-Banner widget — in-grid promo tiles.
 *
 * Reads window.AMH_BANNER ({ api, markets:[...] }, injected by amh-banner.liquid from the shop
 * metafield custom.amh_banner). Two modes, collection pages only:
 *
 *   INJECT  (default)          fetch the collection's active banners and INSERT tiles into the
 *                              product grid — each tile is one grid cell, cloned classes from a
 *                              real product cell so it sizes pixel-identically. First tile lands
 *                              within the first two rows, then every ~7th cell, max 6.
 *   LANDING (?amh.banner=<id>) the shopper clicked a tile: swap the grid's children for EXACTLY
 *                              the banner group's product cards (best discount first) + a clear bar.
 *
 * PERFORMANCE CONTRACT (hard): script is `defer`red, all work starts after load+idle, ONE config
 * fetch per collection view (sessionStorage-cached 5 min), images lazy + sized by the grid row
 * (zero CLS — tiles adopt the row height like any card), setTimeout debounce (never rAF — hidden
 * tabs starve it), and every failure path is silent: the native page is never broken.
 */
(function () {
  "use strict";
  var CFG = window.AMH_BANNER;
  if (!CFG || !CFG.api) return;
  var API = String(CFG.api).replace(/\/+$/, "");

  var HOST_MARKET = {
    "artmie.sk": "SK", "artmie.si": "SI", "artmie.gr": "GR", "artmie.hr": "HR", "artmie.it": "IT",
    "artmie.de": "DE", "artmie.at": "AT", "artmie.bg": "BG", "artmie.cz": "CZ", "artmie.hu": "HU",
    "artmie.ro": "RO", "artmie.rs": "RS", "artmie.ba": "BA", "artmie.mk": "MK", "artmie.pl": "PL",
  };
  var market = HOST_MARKET[location.hostname.replace(/^www\./, "")] || CFG.market;
  if (!market) return;
  if (Array.isArray(CFG.markets) && CFG.markets.length && CFG.markets.indexOf(market) === -1) return;

  var CUR = { SK: "€", SI: "€", GR: "€", HR: "€", IT: "€", DE: "€", AT: "€", BG: "€", CZ: "Kč", HU: "Ft", RO: "lei", RS: "RSD", BA: "KM", MK: "ден", PL: "zł" };
  var cur = CUR[market] || "€";

  var FIRST_SLOT = 3; // 4-col desktop: 1st row; 2-col mobile: 2nd row — always "first two rows"
  var SLOT_STEP = 7; // then every ~7th cell
  var MAX_TILES = 6;

  function collectionFromPath() {
    var m = location.pathname.match(/\/collections\/([a-z0-9][a-z0-9-]*)\/?$/);
    return m ? m[1] : null;
  }
  function gridEl() {
    return document.querySelector("#ResultsList, .main-collection-grid, #ProductGridContainer");
  }
  /**
   * The REAL cell container + cells. Horizon nests: #ResultsList > div > ul.product-grid >
   * li.product-grid__item > product-card — so ascend from a product card until the parent
   * holds ≥2 card-bearing children (the <ul>), instead of trusting the grid's direct children.
   */
  function cellsInfo() {
    var grid = gridEl();
    if (!grid) return null;
    var card = grid.querySelector("product-card, .product-card");
    if (!card) return null;
    var el = card;
    while (el.parentElement && el.parentElement !== grid.parentElement) {
      var sibs = el.parentElement.children, n = 0;
      for (var i = 0; i < sibs.length && n < 2; i++) {
        var s = sibs[i];
        if (s.matches("product-card, .product-card") || s.querySelector("product-card, .product-card")) n++;
      }
      if (n >= 2) break; // el's siblings are the cells
      el = el.parentElement;
    }
    var container = el.parentElement || grid;
    var out = [], kids = container.children;
    for (var j = 0; j < kids.length; j++) {
      var k = kids[j];
      if (k.getAttribute && k.getAttribute("data-amh-banner")) continue;
      if (k.matches("product-card, .product-card") || k.querySelector("product-card, .product-card, a[href*='/products/']")) out.push(k);
    }
    return { grid: grid, container: container, cells: out };
  }

  // ── Styles (one <style>, tile-scoped, theme-agnostic) ──
  var css = document.createElement("style");
  css.textContent =
    ".amh-bn{position:relative;display:flex;flex-direction:column;justify-content:space-between;height:100%;min-height:220px;border-radius:12px;overflow:hidden;text-decoration:none;color:#fff;background:#5b2160;isolation:isolate}" +
    ".amh-bn__img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:-1}" +
    ".amh-bn::after{content:'';position:absolute;inset:0;background:linear-gradient(180deg,rgba(20,8,28,.18),rgba(20,8,28,.44));z-index:-1}" +
    ".amh-bn__in{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;flex:1;padding:14px 10px;gap:2px}" +
    ".amh-bn__label{font-size:13px;font-weight:600;letter-spacing:.02em;text-shadow:0 1px 6px rgba(0,0,0,.45);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}" +
    ".amh-bn__pre{font-size:13px;font-weight:500;opacity:.95;text-shadow:0 1px 6px rgba(0,0,0,.45);margin-top:6px}" +
    ".amh-bn__pct{font-size:clamp(38px,6vw,58px);font-weight:800;line-height:1;letter-spacing:-.02em;text-shadow:0 2px 14px rgba(0,0,0,.5)}" +
    ".amh-bn__cta{align-self:center;margin:0 0 14px;padding:7px 16px;border-radius:999px;background:#fff;color:#1a1a1a;font-size:12.5px;font-weight:700}" +
    ".amh-bn:hover .amh-bn__cta{background:#f2f2f2}" +
    ".amh-bn-bar{display:flex;align-items:center;gap:10px;justify-content:space-between;margin:0 0 14px;padding:10px 14px;border:1px solid #eee;border-radius:12px;background:#faf7fb;font-size:14px}" +
    ".amh-bn-bar b{font-weight:700}" +
    ".amh-bn-bar a{color:#5b2160;font-weight:600;text-decoration:none;white-space:nowrap}" +
    ".amh-bn-card{display:block;height:100%;text-decoration:none;color:inherit;border:1px solid #eee;border-radius:12px;overflow:hidden;background:#fff}" +
    ".amh-bn-card__im{position:relative;width:100%;aspect-ratio:1/1;background:#f6f6f6}" +
    ".amh-bn-card__im img{width:100%;height:100%;object-fit:cover;display:block}" +
    ".amh-bn-card__off{position:absolute;top:8px;left:8px;background:#e8542f;color:#fff;font-size:11px;font-weight:700;padding:2px 7px;border-radius:6px}" +
    ".amh-bn-card__b{padding:10px 10px 12px}" +
    ".amh-bn-card__t{font-size:13px;line-height:1.3;color:#222;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:34px}" +
    ".amh-bn-card__p{margin-top:6px;font-size:14px;font-weight:700;color:#1a1a1a}" +
    ".amh-bn-card__p s{color:#999;font-weight:400;font-size:12.5px;margin-left:6px}" +
    ".amh-bn-more{display:block;margin:18px auto 4px;padding:10px 22px;border:1px solid #ddd;border-radius:999px;background:#fff;font-size:13.5px;font-weight:600;cursor:pointer}";
  var cssMounted = false;
  function mountCss() { if (!cssMounted) { document.head.appendChild(css); cssMounted = true; } }

  function money(v) {
    if (v == null || isNaN(v)) return "";
    var n = (Math.round(v * 100) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return n + " " + cur;
  }

  /** New grid cell that inherits the SIBLING cell's tag + classes → identical sizing, zero CLS.
   *  Nth-item modifiers (product-grid__item--3) are stripped — they style a specific position. */
  function makeCell(sibling) {
    var cell = document.createElement(sibling.tagName);
    cell.className = String(sibling.className).replace(/\b[\w-]+--\d+\b/g, "").replace(/\s+/g, " ").trim();
    cell.setAttribute("data-amh-banner", "1");
    return cell;
  }

  // ── INJECT mode ──
  var COLLECTION = null;
  var injected = false; // per-view flag; reset on navigation
  var lastData = null;

  function bannersUrl(coll) {
    return API + "/api/public/banners?market=" + encodeURIComponent(market) + "&collection=" + encodeURIComponent(coll);
  }
  function cacheKey(coll) { return "amhB1:" + market + ":" + coll; }
  function fetchBanners(coll) {
    try {
      var c = JSON.parse(sessionStorage.getItem(cacheKey(coll)) || "0");
      if (c && c.t && Date.now() - c.t < 300000) return Promise.resolve(c.banners);
    } catch (e) { /* ignore */ }
    return fetch(bannersUrl(coll)).then(function (r) { return r.json(); }).then(function (j) {
      var banners = (j && j.banners) || [];
      try { sessionStorage.setItem(cacheKey(coll), JSON.stringify({ t: Date.now(), banners: banners })); } catch (e) { /* ignore */ }
      return banners;
    });
  }

  function tileFor(banner, sibling) {
    var cell = makeCell(sibling);
    var a = document.createElement("a");
    a.className = "amh-bn";
    a.href = location.pathname + "?amh.banner=" + encodeURIComponent(banner.id);
    var img = document.createElement("img");
    img.className = "amh-bn__img";
    img.loading = "lazy";
    img.decoding = "async";
    img.alt = "";
    img.src = banner.image;
    a.appendChild(img);
    var inWrap = document.createElement("div");
    inWrap.className = "amh-bn__in";
    var label = document.createElement("span");
    label.className = "amh-bn__label";
    label.textContent = banner.label || "";
    var pre = document.createElement("span");
    pre.className = "amh-bn__pre";
    pre.textContent = banner.prefix || "";
    var pct = document.createElement("span");
    pct.className = "amh-bn__pct";
    pct.textContent = "−" + banner.pct + " %";
    inWrap.appendChild(label); inWrap.appendChild(pre); inWrap.appendChild(pct);
    a.appendChild(inWrap);
    var cta = document.createElement("span");
    cta.className = "amh-bn__cta";
    cta.textContent = banner.cta || "";
    a.appendChild(cta);
    cell.appendChild(a);
    return cell;
  }

  function injectTiles() {
    if (!lastData || !lastData.length) return;
    var info = cellsInfo();
    if (!info) return;
    // already present? (mutation re-runs must be idempotent)
    if (info.container.querySelector("[data-amh-banner]")) return;
    var cells = info.cells;
    if (cells.length < 4) return; // tiny grids: a banner would dominate — skip
    mountCss();
    var placed = 0;
    for (var i = 0; i < lastData.length && placed < MAX_TILES; i++) {
      // Each earlier tile shifts visual positions by one, so step by SLOT_STEP-1 over the
      // ORIGINAL cells → visual positions land at 3, 10, 17, … (every 7th cell).
      var idx = FIRST_SLOT + placed * (SLOT_STEP - 1);
      if (idx >= cells.length) break; // only place where it visually fits
      var tile = tileFor(lastData[i], cells[0]);
      cells[idx].parentNode.insertBefore(tile, cells[idx]);
      placed++;
    }
  }

  // ── LANDING mode ──
  function landingId() {
    try { return new URLSearchParams(location.search).get("amh.banner"); } catch (e) { return null; }
  }
  function cardEl(card, sibling) {
    var cell = makeCell(sibling);
    var a = document.createElement("a");
    a.className = "amh-bn-card";
    a.href = card.url || ("/products/" + card.handle);
    var im = document.createElement("div");
    im.className = "amh-bn-card__im";
    if (card.image) {
      var img = document.createElement("img");
      img.loading = "lazy"; img.decoding = "async"; img.alt = card.title || ""; img.src = card.image;
      im.appendChild(img);
    }
    var p = card.price, c = card.compareAt;
    if (c && p && c > p) {
      var off = document.createElement("span");
      off.className = "amh-bn-card__off";
      off.textContent = "−" + Math.round((1 - p / c) * 100) + "%";
      im.appendChild(off);
    }
    a.appendChild(im);
    var b = document.createElement("div");
    b.className = "amh-bn-card__b";
    var t = document.createElement("div");
    t.className = "amh-bn-card__t";
    t.textContent = card.title || "";
    b.appendChild(t);
    var pr = document.createElement("div");
    pr.className = "amh-bn-card__p";
    pr.textContent = money(p);
    if (c && p && c > p) {
      var s = document.createElement("s");
      s.textContent = money(c);
      pr.appendChild(s);
    }
    b.appendChild(pr);
    a.appendChild(b);
    cell.appendChild(a);
    return cell;
  }

  function renderLanding(id) {
    var info = cellsInfo();
    if (!info || !info.cells.length) return;
    var grid = info.container; // the true cell container (ul.product-grid on Horizon)
    var proto = info.cells[0];
    var page = 1;
    mountCss();
    fetch(API + "/api/public/banners/products?id=" + encodeURIComponent(id) + "&page=1")
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.cards || !j.cards.length) return; // silent: native page stays
        // clear bar above the grid
        var sec = grid.closest('[id^="shopify-section-"]') || grid.parentNode;
        var bar = document.createElement("div");
        bar.className = "amh-bn-bar";
        bar.setAttribute("data-amh-banner", "1");
        var left = document.createElement("span");
        left.innerHTML = "<b>" + (j.title || "") + "</b> · −" + j.pct + " % · " + j.found;
        var clear = document.createElement("a");
        clear.href = location.pathname;
        clear.textContent = "✕";
        bar.appendChild(left); bar.appendChild(clear);
        grid.parentNode.insertBefore(bar, grid);
        // hide native pagination inside this section (it belongs to the native product set)
        var pag = sec && sec.querySelector(".pagination, nav[role='navigation'], .pagination-wrapper");
        if (pag) pag.style.display = "none";

        function fill(cards) {
          var frag = document.createDocumentFragment();
          for (var i = 0; i < cards.length; i++) frag.appendChild(cardEl(cards[i], proto));
          grid.appendChild(frag);
        }
        // swap: native children out, group cards in (grid element + classes stay → layout intact)
        while (grid.firstChild) grid.removeChild(grid.firstChild);
        fill(j.cards);

        if (j.found > j.cards.length) {
          var more = document.createElement("button");
          more.className = "amh-bn-more";
          more.setAttribute("data-amh-banner", "1");
          more.type = "button";
          more.textContent = "+";
          more.addEventListener("click", function () {
            page++;
            fetch(API + "/api/public/banners/products?id=" + encodeURIComponent(id) + "&page=" + page)
              .then(function (r) { return r.json(); })
              .then(function (jj) {
                if (jj && jj.cards && jj.cards.length) fill(jj.cards);
                if (!jj || !jj.cards || page * 24 >= jj.found) more.style.display = "none";
              })
              .catch(function () { more.style.display = "none"; });
          });
          grid.parentNode.insertBefore(more, grid.nextSibling);
        }
      })
      .catch(function () { /* silent — native page remains */ });
  }

  // ── Lifecycle (mirrors amh-filter: soft navigation + theme morphs) ──
  var landingDone = false;
  function activate() {
    var coll = collectionFromPath();
    if (!coll) { COLLECTION = null; return; }
    var id = landingId();
    if (id) {
      if (!landingDone) { landingDone = true; renderLanding(id); }
      return;
    }
    if (coll === COLLECTION && injected) { injectTiles(); return; } // re-inject after morphs
    COLLECTION = coll;
    injected = true;
    fetchBanners(coll).then(function (banners) {
      lastData = banners;
      injectTiles();
    }).catch(function () { /* silent */ });
  }

  // Debounced re-run when the theme re-renders the section (filter widget swaps, morphs).
  var moT = null;
  new MutationObserver(function () {
    if (moT) return;
    moT = setTimeout(function () { moT = null; if (collectionFromPath() && !landingId()) injectTiles(); }, 150);
  }).observe(document.body, { childList: true, subtree: true });

  // Soft navigations (setTimeout poll — runs in background tabs too, unlike rAF).
  var lastHref = location.href;
  setInterval(function () {
    if (location.href === lastHref) return;
    lastHref = location.href;
    COLLECTION = null; injected = false; landingDone = false; lastData = null;
    activate();
  }, 400);
  window.addEventListener("popstate", function () {
    COLLECTION = null; injected = false; landingDone = false;
    activate();
  });

  // Boot only after load + idle — zero critical-path work.
  var whenIdle = window.requestIdleCallback || function (f) { return setTimeout(function () { f(); }, 1); };
  function go() { whenIdle(activate, { timeout: 3000 }); }
  if (document.readyState === "complete") go();
  else window.addEventListener("load", go, { once: true });
})();
